import {
    MenuItem,
    Select,
    SelectChangeEvent,
} from '@mui/material'

import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowDown'
import {
    SkyNetTableTab,
} from 'app/shared-components/SkyNetTable/types/skyNetTable.types'

import useToolbarStyles from '../../SkyNetMasterDataGrid/components/SkyNetDataGridToolbar/SkyNetDataGridToolbar.style'
import useStyles from './TabsDropdown.styles'

type Props = {
    tabs: SkyNetTableTab[],
    value: number,
    onChange: (value: number) => void,
}

const TabsDropdown = ({
    tabs,
    value,
    onChange,
}: Readonly<Props>) => {
    const {
        classes, cx,
    } = useStyles()

    const {
        classes: toolbarClasses,
    } = useToolbarStyles()

    const handleChange = (event: SelectChangeEvent<number>) => {
        onChange(event.target.value)
    }

    if (tabs.length === 1) {
        return (
            <div
                className={cx(classes.root, classes.singleOption, classes.text)}
                data-testid="single-tab"
            >
                {tabs[value].name}
            </div>
        )
    }

    return (
        <Select
            label={tabs[value].name}
            value={value}
            onChange={handleChange}
            variant="standard"
            className={cx(classes.root, classes.text, classes.select)}
            MenuProps={{
                classes: {
                    paper: toolbarClasses.dropdown,
                },
            }}
            IconComponent={KeyboardArrowDown}
        >
            {tabs.map((tab, i) => {
                return (
                    <MenuItem
                        key={tab.name}
                        value={i}
                        className={cx(
                            classes.text,
                            value === i ? classes.selectedOption : null,
                        )}
                    >
                        {tab.name}
                    </MenuItem>
                )
            })}
        </Select>
    )
}

export default TabsDropdown
